var convertHexToRgb = function (hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        }
        : null;
};
export var convertHexPaletteToRgb = function (palette) {
    var newPalette = {};
    Object.keys(palette).forEach(function (key) {
        if (palette[key].hex && !palette[key].value) {
            newPalette[key] = {};
            var rgb = convertHexToRgb(palette[key].hex);
            if (rgb) {
                // formato RGB
                newPalette[key].value = [rgb.r, rgb.g, rgb.b];
            }
            rgb = convertHexToRgb(palette[key].contrast);
            if (rgb) {
                // formato RGBA
                newPalette[key].contrast = [rgb.r, rgb.g, rgb.b];
            }
            newPalette[key].hex = palette[key].hex;
        }
        else {
            newPalette[key] = palette[key];
        }
    });
    return newPalette;
};
